/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A page the agent fetched, with what came back and the injection judge's verdict on it. A fetch spends nothing.
 */
export type ResearchPageFetchCall = {
  /**
   * Indices of the report claims that cited this page — the link from a fetch to the evidence it became. Empty when the page was read but nothing in the final report rests on it.
   */
  citedByClaims?: Array<number> | undefined;
  /**
   * The fetched page's extracted-text size.
   */
  contentBytes?: number | undefined;
  /**
   * A bounded preview of the extracted page text. Untrusted web content.
   */
  contentPreview?: string | undefined;
  /**
   * The fetched page's content type.
   */
  contentType?: string | undefined;
  /**
   * Where the fetch landed after redirects, when it differed.
   */
  finalUrl?: string | undefined;
  /**
   * Whether the judge found the page tried to instruct its reader.
   */
  injectionFlagged?: boolean | undefined;
  /**
   * The judge's reasoning, when it flagged the page.
   */
  judgeRationale?: string | undefined;
  /**
   * Whether the injection judge reached a verdict on this page.
   */
  judged?: boolean | undefined;
  /**
   * Whether the fetch hit its caps and the preview is of a prefix.
   */
  truncated?: boolean | undefined;
  /**
   * The page the agent fetched.
   */
  url?: string | undefined;
};

/** @internal */
export const ResearchPageFetchCall$inboundSchema: z.ZodMiniType<
  ResearchPageFetchCall,
  unknown
> = z.pipe(
  z.object({
    cited_by_claims: z.optional(z.array(z.int())),
    content_bytes: z.optional(z.int()),
    content_preview: z.optional(z.string()),
    content_type: z.optional(z.string()),
    final_url: z.optional(z.string()),
    injection_flagged: z.optional(z.boolean()),
    judge_rationale: z.optional(z.string()),
    judged: z.optional(z.boolean()),
    truncated: z.optional(z.boolean()),
    url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "cited_by_claims": "citedByClaims",
      "content_bytes": "contentBytes",
      "content_preview": "contentPreview",
      "content_type": "contentType",
      "final_url": "finalUrl",
      "injection_flagged": "injectionFlagged",
      "judge_rationale": "judgeRationale",
    });
  }),
);

export function researchPageFetchCallFromJSON(
  jsonString: string,
): SafeParseResult<ResearchPageFetchCall, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResearchPageFetchCall$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResearchPageFetchCall' from JSON`,
  );
}
